import AdminTemplate from './admin-template';

export default AdminTemplate;
